import { render, staticRenderFns } from "./PasswordLoginModify.vue?vue&type=template&id=54ccf952&scoped=true&"
import script from "./PasswordLoginModify.vue?vue&type=script&lang=ts&"
export * from "./PasswordLoginModify.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordLoginModify.vue?vue&type=style&index=0&id=54ccf952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ccf952",
  null
  
)

export default component.exports